import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  // Opçao global para customização do tema
  theme: {
      options: {
        customProperties: false,
      },
    themes: {
      light: {
        primary: '#01579B',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#FFFFFF',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
    lang: {
      locales: { pt },
      current: 'pt',
    },
});
